var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBonusBanner = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 79,
    viewBox: "0 0 94 79",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.5676,
    y: 14.7449,
    width: 50.7226,
    height: 35.9777,
    rx: 5.89798,
    fill: "#F1BD6C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 25.9509,
    width: 35.9777,
    height: 24.7715,
    rx: 5.30818,
    fill: "#E8EDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5635 41.9879C40.2679 40.3911 38.4855 38.0657 37.6538 35.2753C37.3537 34.2581 37.5507 33.179 38.1968 32.313C39.0422 31.1744 40.5359 30.6544 41.8762 31.0553C44.6666 31.8846 46.992 33.667 48.5888 35.9626V25.9509L22.2423 25.9509C19.083 25.9509 16.5148 28.5214 16.5148 31.6784V41.9879H42.5635Z",
    fill: "#83A9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4351 33.6853C59.2129 33.3874 58.8784 33.2087 58.537 33.2087C58.4408 33.2087 58.3423 33.2248 58.2438 33.2523C54.301 34.4253 51.4372 37.8915 50.9515 41.9168C54.9768 41.4311 58.4431 38.5697 59.6138 34.6246C59.7467 34.1916 59.5588 33.8502 59.4351 33.6853Z",
    fill: "#83A9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8795 35.9625C52.4763 33.6669 54.8017 31.8845 57.5922 31.0529C58.9324 30.6519 60.4238 31.1743 61.2715 32.3106C61.9176 33.1766 62.1146 34.258 61.8122 35.2729C60.9828 38.061 59.2004 40.3864 56.9026 41.9855H71.4985V31.6783C71.4985 28.5213 68.9303 25.9508 65.771 25.9508H50.8795V35.9625Z",
    fill: "#83A9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2268 33.2523C41.1283 33.2248 41.0297 33.2087 40.9335 33.2087C40.5945 33.2087 40.2577 33.3874 40.0355 33.6853C39.9117 33.8502 39.7239 34.1916 39.8545 34.6246C41.0275 38.5674 44.4915 41.4289 48.5167 41.9168C48.0333 37.8915 45.1719 34.4253 41.2268 33.2523Z",
    fill: "#83A9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5885 45.8987L43.6721 50.8152C43.4475 51.0397 43.1543 51.1519 42.861 51.1519C42.5678 51.1519 42.2745 51.0397 42.05 50.8174C41.6033 50.3707 41.6033 49.6445 42.05 49.1977L46.9688 44.2789H16.5145V56.8794C16.5145 60.0364 19.0827 62.6069 22.242 62.6069H48.5885V45.8987ZM24.533 48.8609H33.697C34.3294 48.8609 34.8425 49.3741 34.8425 50.0064C34.8425 50.6388 34.3294 51.1519 33.697 51.1519H24.533C23.9007 51.1519 23.3875 50.6388 23.3875 50.0064C23.3875 49.3741 23.9007 48.8609 24.533 48.8609ZM40.57 55.7339H24.533C23.9007 55.7339 23.3875 55.2208 23.3875 54.5884C23.3875 53.9561 23.9007 53.4429 24.533 53.4429H40.57C41.2024 53.4429 41.7155 53.9561 41.7155 54.5884C41.7155 55.2208 41.2024 55.7339 40.57 55.7339Z",
    fill: "#83A9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.499 44.2789L57.4155 49.1954C57.8622 49.6422 57.8622 50.3684 57.4155 50.8152C57.1933 51.0397 56.9 51.1519 56.6068 51.1519C56.3135 51.1519 56.0203 51.0397 55.7958 50.8174L50.8793 45.8987V62.6069H65.7708C68.9301 62.6069 71.4983 60.0364 71.4983 56.8794V44.2789H52.499Z",
    fill: "#83A9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8255 8.24061L61.5006 7.16574C60.4038 4.14021 65.2883 3.04942 64.1914 0L67.5163 1.07487C68.6131 4.12429 63.7286 5.21507 64.8255 8.24061Z",
    fill: "#FCDF98"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3051 8.32612L26.6016 11.1845C23.3536 11.6421 23.1616 6.95972 19.8992 7.40237L21.5937 4.54673C24.8561 4.10408 25.048 8.78645 28.3051 8.32612Z",
    fill: "#84C8B1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8735 78.6818L50.2976 76.5754C50.324 73.2954 54.9835 73.796 55.0267 70.5041L57.6013 72.6011C57.558 75.8931 52.8985 75.3925 52.8735 78.6818Z",
    fill: "#84C8B1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79417 45.2281L0.925654 42.3353C2.54104 39.7211 5.72257 42.3036 7.35623 39.6878L8.22832 42.5725C6.59466 45.1883 3.41313 42.6058 1.79417 45.2281Z",
    fill: "#F4AE72"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8607 64.3157L82.7154 60.2344C86.441 58.4517 88.5372 64.088 92.2629 62.3054L91.3633 66.4256C87.6748 68.1604 85.5864 62.533 81.8607 64.3157Z",
    fill: "#DCDCDC"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBonusBanner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bonus-banner.dbd8f3ea.svg";
export { ForwardRef as ReactComponent };